import React from 'react';

import styles from './footer.scss';

interface Props {
  children?: any;
  className?: string;
}

export const Footer: React.FC<Props> = ({ className, children }) => {
  if (!children) {
    return null;
  }

  return <div className={className || styles.container}>{children}</div>;
};
